/**
 * Javascript for the review questions section
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/val/val.js";

export default (obj, commentary) => {
	obj.on("change", function () {
		const level = parseInt($(this).val());
		commentary.css("display", function () {
			return $(this).data("level") === level ? "" : "none";
		});
	});
};